// extracted by mini-css-extract-plugin
export default {"container":"_0GX5giUbDlXrYDR_lqQ","contentContainer":"QO5EYb2fdHkI9khqY0zg"};